/** Regional indicator symbol A; a flag emoji is the code's two letters shifted onto these. */
const REGIONAL_INDICATOR_A = 0x1f1e6;

/** What the desk reads for a destination: the flag, the ISO code and, on hover, the country's English name. */
export interface CountryTag {
  code: string;
  flag: string;
  name: string;
}

const englishCountryName = (code: string): string => {
  try {
    return new Intl.DisplayNames(['en'], { type: 'region' }).of(code) ?? code;
  } catch {
    return code;
  }
};

/** An ISO 3166-1 alpha-2 code as a tag; null when the order carries no usable code, so nothing is guessed. */
export const countryTagOf = (countryCode: string | null | undefined): CountryTag | null => {
  const code = (countryCode ?? '').trim().toUpperCase();
  if (!/^[A-Z]{2}$/.test(code)) {
    return null;
  }
  const flag = String.fromCodePoint(...[...code].map((letter) => REGIONAL_INDICATOR_A + letter.charCodeAt(0) - 65));
  return { code, flag, name: englishCountryName(code) };
};
